var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pb-24"},[_c('h2',{staticClass:"text-xl pb-3"},[_vm._v("Payment Pending...")]),_c('span',{staticClass:"pb-4 text-lg block"},[_vm._v(_vm._s(_vm.userMessage))])]),_c('Spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }